import type { ListingPageResult } from '@/features/plp/domain/models/ProductListing';
import type { BrowsingHistoryRepository } from '../../domain/interfaces/BrowsingHistoryRepository';
import type { BrowsingHistoryCategoryList } from '../../domain/models/BrowsingHistory';
import { adaptVisitorDataToListingPageResult } from '../../infra/mappers/browsingHistory.mapper';

export class BrowsingHistoryService {
  constructor(private readonly repository: BrowsingHistoryRepository) {}

  async getListingPage(
    category: string | undefined,
    pageNumber: number,
    opts?: { signal?: AbortSignal },
  ): Promise<ListingPageResult> {
    void opts?.signal;
    const apiPage = pageNumber - 1;
    const response = await this.repository.getVisitorData(category, apiPage);
    return adaptVisitorDataToListingPageResult(response);
  }

  getCategories(): Promise<BrowsingHistoryCategoryList> {
    return this.repository.getCategories();
  }
}

export function createBrowsingHistoryService(repository: BrowsingHistoryRepository): BrowsingHistoryService {
  return new BrowsingHistoryService(repository);
}
